import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {
    GeneralForm: {},
    ProjectForm: {},
    PlanForm: {},
    OOIForm: {},
    AttachmentForm: [],
    SummaryData: {}
}

const getters = {

}

const actions = {
    getMasterFormC ({ commit }, params) {
        return Service.CForm.getMasterFormC(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    storeFormC ({ commit }, data) {
        return Service.CForm.storeFormC(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateFormC ({ commit }, data) {
        return Service.CForm.updateFormC(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
    updateFormCStatus ({ commit }, data) {
        return Service.CForm.updateFormCStatus(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getFormCList ({ commit }, data) {
        return Service.CForm.getFormCList(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    deleteFormCList ({ commit }, data) {
        return Service.CForm.deleteFormCList(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    getEditMasterFormC ({ commit }, data) {
        return Service.CForm.getEditMasterFormC(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    storeNewProgressFormC ({ commit }, data) {
        return Service.CForm.storeNewProgressFormC(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
    syncKPI ({ commit }, data) {
        return Service.CForm.syncKPI(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },
}

const mutations = {
    setGeneralForm (state, val) {
        state.GeneralForm = val
    },
    setProjectForm (state, val) {
        state.ProjectForm = val
    },
    setPlanForm (state, val) {
        state.PlanForm = val
    },
    setOOIForm (state, val) {
        state.OOIForm = val
    },
    setAttachmentForm (state, val) {
        state.AttachmentForm = val
    },
    addSummaryData (state, val) {
        state.SummaryData = {
            ...state.SummaryData,
            ...val
        }
    },
    clearSummaryData (state) {
        state.SummaryData = {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
